import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ISelectable, SelectGroupComponent, SelectGroupMode } from '../../../basic/select-group/select-group.component';
import { AppColor } from '../../../shared/color/color';
import { EnumUtils } from '../../../shared/utils/enum-utils';
import { ColorSelectable } from '../color-selectable';
import { ColorSelectorItemComponent } from './color-selector-item/color-selector-item.component';

@Component({
  selector: 'app-color-selector-x',
  standalone: true,
  imports: [CommonModule, FormsModule, NzIconModule, ColorSelectorItemComponent, SelectGroupComponent],
  templateUrl: './color-selector-x.component.html',
  styleUrls: ['./color-selector-x.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ColorSelectorXComponent,
      multi: true,
    },
  ],
})
export class ColorSelectorXComponent {
  @Input() color?: string;
  @Output() colorChange: EventEmitter<string> = new EventEmitter();

  colorSelectableList: ColorSelectable[] = [];

  SelectGroupMode = SelectGroupMode;

  ngOnInit(): void {
    const colorList = EnumUtils.getAllValues(AppColor);
    colorList.forEach((color) => {
      const colorSelectable = {
        color,
        isSelected: false,
      };
      if (this.color === color) {
        colorSelectable.isSelected = true;
      }
      this.colorSelectableList.push(colorSelectable);
    });
  }

  private updateColorSelectableList(): void {
    this.colorSelectableList.forEach((item) => {
      item.isSelected = item.color === this.color;
    });
  }

  onItemChange(event: ISelectable): void {
    const selectedColor = (event as ColorSelectable).color;
    this.color = selectedColor;
    this.onChange(selectedColor);
    this.onTouched();

    this.colorChange.emit((event as ColorSelectable).color);
  }

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.color = value;
    this.updateColorSelectableList();
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if needed
  }
}
